/* eslint-disable max-len */
import React, { useEffect, useState } from "react";

import { CentralLoadingIndicator } from "../../../components";
import ContactSupportBox from "../../../components/ContactSupportBox/ContactSupportBox";
import HospitalCardList from "../../../components/HospitalCardList/HospitalCardList";
import { ILocationItemResponse } from "../../../services/edit-hospital-location/edit-hospital-location.interface";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { MODALS } from "../../../config/params";
import NullStateMessage from "../../../components/NullStateMessage/NullStateMessage";
import { useDashboard } from "../../../services/dashboard/dashboard.service";
import { useHospitalList } from "../../../services/edit-hospital-location/edit-hospital-location.service";
import { useModal } from "../../../context/ModalContext";
import { useUpdateLocationStore } from "../../../hooks/redux-hooks/updateLocation-store/updateLocation-store";
import { userActivityLogger } from "../../../utils/mixpanel";
import { useHospitalDetailsListStore } from "../../../hooks/redux-hooks/hospital-details-list-store/hospital-details-list-store";

export const getContactString = (contact: string) =>{
  if (/iPad|iPhone|iPod|Mac/.test(navigator.userAgent)) {
    return (`facetime:${contact}`);
  } else {
    return (`tel:${contact}`);
  }
};

const ChangeHospitalContainer = () => {
  const { metroLocations, loading, getMetroLocations, currentLocation } = useHospitalList();
  const [currentLocationContact, setCurrentLocationContact] = useState<string>("");
  const [currentHospital, setCurrentHospital] = useState<ILocationItemResponse>();
  const { getDashBoardData, dashboard, loading: dashboardDataLoading } = useDashboard();
  const { setLocationSelected } = useUpdateLocationStore();
  const { setCurrentLocation, setHospitalList, setIsHospitalListUpdated, currentLocation: currentHospitalLocation, hospitalDetailsList, isHospitalListUpdated } = useHospitalDetailsListStore();


  const { openModal } = useModal();


  useEffect(()=>{
    // call the getMetroLocations api call if the store is not already updated
    !isHospitalListUpdated && getMetroLocations();
    getDashBoardData();
  }, []);

  useEffect(()=>{
    !isHospitalListUpdated && getMetroLocations();
  }, [isHospitalListUpdated]);

  useEffect(() => {
    // will execute if the getMetroLocations response is not already present in store
    if (metroLocations && currentLocation) {
      setHospitalList(metroLocations);
      setCurrentLocation(currentLocation);
      setIsHospitalListUpdated(true);
      const currentLocationItem = metroLocations.find(
        (item) => item?.idLocation === currentLocation);

      if (currentLocationItem) {
        setCurrentHospital(currentLocationItem);
      }
    }
  }, [metroLocations]);

  useEffect(() => {
    // will execute if the getMetroLocations response is already present in store
    if (hospitalDetailsList && currentHospitalLocation) {
      const currentLocationItem = hospitalDetailsList.find(
        (item: any) => item?.idLocation === currentHospitalLocation);

      if (currentLocationItem) {
        setCurrentHospital(currentLocationItem);
      }
    }
  }, []);

  useEffect(() => {
    if (currentHospital) {
      setCurrentLocationContact(getContactString(currentHospital.phoneNumber));
    }
  }, [currentHospital]);

  const onCardSelect = (data: ILocationItemResponse) => {
    userActivityLogger(MIXPANEL_EVENTS.UPDATE_HOSPITAL_PREVIEW, {
      current_hospital: currentHospital?.locationName,
      new_hospital: data.locationName,
    });
    if (!dashboardDataLoading && dashboard && dashboard.appointments?.length > 0) {
      openModal(MODALS.MANAGE_HOSPITAL_CHANGE);
    } else {
      setLocationSelected([data]);
      openModal(MODALS.UPDATE_HOSPITAL_PREVIEW);
    }
  };

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.UPDATE_HOSPITAL, {});
  }, []);

  if (loading || dashboardDataLoading) {
    return <CentralLoadingIndicator />;
  };

  return (
    <div className="h-[75vh] flex justify-between flex-col md:flex-row">
      {((hospitalDetailsList && hospitalDetailsList.length>1 && isHospitalListUpdated) || (metroLocations && metroLocations.length > 1)) && currentHospital ?
        <div className="px-2 w-full
        md:w-6/12 h-full overflow-y-scroll scroll-hide">
          <HospitalCardList hospitalDetails={isHospitalListUpdated ? hospitalDetailsList : metroLocations} currentHospital={ currentHospital }
            onCardSelect={onCardSelect} />
        </div>:
        <div className="w-full">
          <NullStateMessage
            imageSrc="/assets/icons/newUser2.png"
            message="Oops...could not find a hospital near you!"
            subMessage={
              <div>
                <div>
                Please contact
                  {" "}<span className="font-semibold">{currentHospital?.locationName}</span>{" "}
                  directly to change your hospital and book your next appointment.
                </div>
                <a href={currentHospital && getContactString(currentHospital?.phoneNumber)}
                  className="text-gv-yellow font-semibold">{currentHospital?.phoneNumber}</a>
              </div>
            }
          />
        </div>
      }
      {((hospitalDetailsList && hospitalDetailsList.length>1 && isHospitalListUpdated) || (metroLocations && metroLocations.length > 1)) && currentHospital && <div className="w-full md:w-5/12">
        <ContactSupportBox contact={currentLocationContact} message={"Moving to a new city?"} />
      </div>}
    </div>
  );
};

export default ChangeHospitalContainer;
